import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NONE = { can_view: false, can_manage: false, is_master: false, flag: 'off' };
let cache = { userId: null, data: null };
let inflight = { userId: null, promise: null };

const fetchAccess = (uid) => {
  if (inflight.userId !== uid || !inflight.promise) {
    inflight = { userId: uid, promise: axios.get(`${API_URL}/org/access/me`).then(({ data }) => data).finally(() => { inflight = { userId: null, promise: null }; }) };
  }
  return inflight.promise;
};

export function useOrgAccess() {
  const { user } = useAuth();
  const uid = user?.id || null;
  const [access, setAccess] = useState(cache.userId === uid && cache.data ? cache.data : NONE);
  const reload = useCallback(async () => {
    if (!uid || user?.role !== 'admin') { cache = { userId: uid, data: NONE }; setAccess(NONE); return; }
    try {
      const data = await fetchAccess(uid);
      cache = { userId: uid, data };
      setAccess(data);
    } catch { setAccess(NONE); }
  }, [uid, user?.role]);
  useEffect(() => {
    if (cache.userId === uid && cache.data) setAccess(cache.data); else reload();
  }, [uid, reload]);
  return { ...access, reload };
}
